import React, { Component, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MenuLink from 'base/containers/Menu/MenuLink';
import theme from 'theme/index';

const FolderTreeMenuLink = styled(MenuLink)`
  padding: 0;
`;

const Node = styled.div`
  position: relative;
  overflow: hidden;
  min-width: 100%;
  
  white-space: nowrap;
  text-align: left;
  color: ${theme.colors.light};
  background: ${(props) => {
    if (props.canDrop && !props.isOver) {
      return 'green';
    } if (!props.canDrop && props.isOver) {
      return 'red';
    }
    return 'transparent';
  }};
  &:hover {
    background: ${theme.colors.darker};
    height: 100%;
    cursor: pointer;
  }
`;

const NodeContent = styled.div`
  display: flex;
  align-items: center;
`;

class FolderThemeTreeNodeRenderer extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.bound = {
      handleMouseOver: this.handleMouseOver.bind(this),
      handleMouseLeave: this.handleMouseLeave.bind(this),
    };
  }

  handleMouseOver() {
    if (!this.state.highlight) {
      this.setState({ highlight: true });
    }
  }

  handleMouseLeave() {
    this.setState({ highlight: false });
  }

  render() {
    const {
      children,
      swapFrom,
      swapLength,
      swapDepth,
      scaffoldBlockPxWidth,
      lowerSiblingCounts,
      connectDropTarget,
      isOver,
      draggedNode,
      canDrop,
      treeIndex,
      getPrevRow, // Delete from otherProps
      node, // Delete from otherProps
      path, // Delete from otherProps
      ...otherProps
    } = this.props;
    // Construct the scaffold representing the structure of the tree
    // const scaffoldBlockCount = lowerSiblingCounts.length - 1;
    // const isValidDrop = canDrop && !isOver;
    let dropType;
    if (canDrop && !isOver) {
      dropType = 'validDrop';
    } else if (!canDrop && isOver) {
      dropType = 'invalidDrop';
    }

    const nodeContent = (
      <NodeContent>
        {Children.map(children, (child) => cloneElement(child, {
          isOver,
          canDrop,
          draggedNode,
        }))}
      </NodeContent>
    );


    return (
      <Node
        dropType={dropType}
        onMouseOver={this.bound.handleMouseOver}
        onMouseLeave={this.bound.handleMouseLeave}
        {...otherProps}
        onFocus={() => {}}
        ref={(instance) => connectDropTarget(instance)}
        canDrop={canDrop}
        isOver={isOver}
      >
        {node.route
          ? <FolderTreeMenuLink to={node.route} activeClassName="is-active">{nodeContent}</FolderTreeMenuLink>
          : nodeContent}
      </Node>
    );
  }
}

FolderThemeTreeNodeRenderer.defaultProps = {
  swapFrom: null,
  swapDepth: null,
  swapLength: null,
  canDrop: false,
  draggedNode: null,
};

FolderThemeTreeNodeRenderer.propTypes = {
  treeIndex: PropTypes.number.isRequired,
  swapFrom: PropTypes.number,
  swapDepth: PropTypes.number,
  swapLength: PropTypes.number,
  scaffoldBlockPxWidth: PropTypes.number.isRequired,
  lowerSiblingCounts: PropTypes.arrayOf(PropTypes.number).isRequired,

  children: PropTypes.node.isRequired,

  // Drop target
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  canDrop: PropTypes.bool,
  draggedNode: PropTypes.shape({}),

  // used in dndManager
  getPrevRow: PropTypes.func.isRequired,
  node: PropTypes.shape({}).isRequired,
  path: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
};

export default FolderThemeTreeNodeRenderer;
